import React from 'react';
import { Route, withRouter } from 'react-router';
import MarutiSyncList from "./components/marutiSyncList";
import { Container } from 'semantic-ui-react'
// import OldSyncPullForm from './components/oldSyncPullForm';


const MarutiSync = () => {
    return (
        <div>
            <Route path="/marutisync" component={withRouter(MarutiSyncList)} />
            {/* <Route path="/oldsync" component={OldSyncPullForm} /> */}
        </div>
    )
};

export default MarutiSync;

